import React, { useState } from "react";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { CircularProgress } from "@mui/material";
import {
  errorToaster,
  successToaster,
} from "../../../../helper/toasterConfiguration";
import { MdMiscellaneousServices } from "react-icons/md";

const GetServiceButton = ({
  id,
  setIsGetServicesLoading,
  isGetServicesLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const getPanelServices = async (e, id) => {
    e.preventDefault();
    setIsLoading(true);
    setIsGetServicesLoading(true);
    try {
      const { response, message } = await Helper.Get({
        url: api_Routes.Panels.GetServices + id,
        hasToken: true,
      });
      if (response) {
        successToaster(message);
      } else {
        errorToaster("Failed to read");
      }
    } catch (error) {
      errorToaster("Failed to read");
    } finally {
      setIsLoading(false);
      setIsGetServicesLoading(false);
    }
  };

  return (
    <div className="relative group">
      {/* Tooltip */}
      <div className="absolute bottom-full -right-2 mb-3 opacity-0 group-hover:opacity-100 transition-opacity text-xs bg-black text-white rounded px-2 py-1 whitespace-nowrap">
        Get Services
      </div>

      {/* Button */}
      <div
        className={`${
          isGetServicesLoading
            ? "text-gray-500 cursor-not-allowed"
            : "text-blue-500 cursor-pointer"
        } underline text-xs whitespace-nowrap`}
        onClick={(e) => {
          !isGetServicesLoading && getPanelServices(e, id);
        }}
      >
        {isLoading ? (
          <CircularProgress size={16} />
        ) : (
          <MdMiscellaneousServices size={16} />
        )}
      </div>
    </div>
  );
};

export default GetServiceButton;
